import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';

/**
 * Create an instance of the Graphic and returns it
 * @param {Object} mapObject - map object
 * @param {Object} configs
 * @param {Object} configs.point - the coordinates to draw the marker
 * @param {Url} configs.icon - the svg icon used for the marker
 */
export const createGraphic = async ({ mapObject, configs }) =>
  await handleGraphic({ configs });

/**
 * Creates a Graphic based on the configs
 * @param {Object} configs
 * @param {Object} configs.geometry - Esri Maps' geometry class
 * @param {Object} configs.point
 * @param {Number} configs.point.x - longitude
 * @param {Number} configs.point.y - latitude
 */
const handleGraphic = ({ configs }) => {
  const point = new Point(configs.point);
  const graphic = new Graphic({
    geometry: configs.geometry || point,
    ...configs,
  });
  return {
    graphic,
    ...(configs.point ? { point } : {}),
  };
};
